import React, { PureComponent } from 'react';

export default class DeliveryStepIndicator extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      steps: ['bag', 'address', 'payment']
    };
  }

  render() {
    let { steps = [] } = this.state;
    let {
      currentIndex: activeIndex = 0,
      withDeliveryIndicator = false,
      newDesignLuxe
    } = this.props;
    return (
      <div
        className={`${newDesignLuxe ? 'luxe-newdesign' : ''} cart-journey-indicator-wrapper ${
          withDeliveryIndicator ? 'top-header' : ''
        }`}
      >
        <ul className="cart-journey-indicator">
          {steps.map((item = '', key) => {
            return (
              <li key={key} className="cart-journey-list">
                {this.getClassBasedOnIndex(key, activeIndex) === 'pre-active' ? (
                  <a 
                    className="pagelink" 
                    href={this.getLink(key)} 
                    aria-label={
                      withDeliveryIndicator && key === 1
                        ? 'Delivery Details '
                        : `${item}`
                    }
                  >
                    <section
                      style={newDesignLuxe ? { width: '28px', height: '28px' } : null}
                      className={`${item}-wrapper outer-circle ${this.getClassBasedOnIndex(
                        key,
                        activeIndex
                      )}`}
                    >
                      <section
                        className={`inner-circle ${this.getClassBasedOnIndex(key, activeIndex)}`}
                        aria-hidden='true'
                        tabIndex={-1}
                      >
                        <span className={`icons ${this.getIconClass(item)}`} />
                      </section>
                      <p
                        style={newDesignLuxe ? { color: '#121212' } : null}
                        className={`current-journey-label ${this.getClassBasedOnIndex(key, activeIndex)}`} aria-label={`${withDeliveryIndicator && key===1 ? 'Delivery Details' :item}`}
                        aria-hidden="true"
                        tabIndex={-1}
                      >
                        {withDeliveryIndicator && key === 1 ? <span>Delivery Details</span> : item}
                      </p>
                    </section>
                  </a>
                ) : (
                  <section
                    style={newDesignLuxe ? { width: '28px', height: '28px' } : null}
                    className={`${item}-wrapper outer-circle ${this.getClassBasedOnIndex(
                      key,
                      activeIndex
                    )}`}
                    aria-label={
                      withDeliveryIndicator && key === 1
                        ? 'Delivery Details '
                        : `${item}`
                    }
                    tabIndex={key <= activeIndex ?  0 : -1}
                  >
                    <section
                      className={`inner-circle ${this.getClassBasedOnIndex(key, activeIndex)}`}
                      tabIndex={-1}
                      aria-hidden="true"
                    >
                      <span className={`icons ${this.getIconClass(item)}`} />
                    </section>
                    <p
                      style={newDesignLuxe ? { color: '#121212' } : null}
                      className={`current-journey-label ${this.getClassBasedOnIndex(key, activeIndex)}`} aria-label={`${withDeliveryIndicator && key===1 ? 'Delivery Details' :item}`}
                      tabIndex={-1}
                      aria-hidden="true"
                    >
                      {withDeliveryIndicator && key === 1 ? <span>Delivery Details</span> : item}
                    </p>
                  </section>
                )}

                <div
                  className={`divider-separator ${this.getClassBasedOnIndex(key, activeIndex)}`}
                  aria-hidden="true"
                  tabIndex={-1}
                />
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  getClassBasedOnIndex(currentIndex, activeIndex) {
    let classes = '';
    if (currentIndex < activeIndex) {
      classes = 'pre-active';
    } else if (currentIndex == activeIndex) {
      classes = 'active';
    }
    return classes;
  }

  getLink(index = 0) {
    let href = '#';
    if (index === 0) {
      href = '/cart';
    } else if (index === 1) {
      href = '/shipping';
    } else if (index === 2) {
      href = '/checkout';
    }
    return href;
  }

  getAltTxt(index = 0) {
    let altTxt = '';
    if (index === 0) {
      altTxt = 'Cart icon';
    } else if (index === 1) {
      altTxt = 'Shipping icon';
    } else if (index === 2) {
      altTxt = 'Checkout icon';
    }
    return altTxt;
  }

  getIconClass(item) {
    let classes = '';
    switch (item) {
      case 'bag':
        classes = 'ic-cart';
        break;
      case 'address':
        classes = 'ic-address';
        break;
      case 'payment':
        classes = 'ic-Rupee';
        break;
    }
    return classes;
  }
}
